import { FunctionComponent, useCallback, useState } from "react";
import { CommerceIcon } from "@/components/common/icons";

const NotAvailableTip: FunctionComponent<{
  title: string;
  desc: string;
}> = ({ title, desc }) => {
  return (
    <div className="flex flex-col items-center justify-center max-w-[418px]">
      <CommerceIcon></CommerceIcon>
      <div className="text-xl font-semibold mt-8">{title}</div>
      <div className="mt-4 text-gray1 text-center">{desc}</div>
    </div>
  );
};

export default NotAvailableTip;
